import {
  FinancialAccountPrimaryUse,
  type FinancialAccount,
} from '@/reducers/finances/financialAccountsReducer'

export enum DeclaredUse {
  business = 'business',
  businessWithPersonalCharges = 'businessWithPersonalCharges',
  personal = 'personal',
  personalWithBusinessCharges = 'personalWithBusinessCharges',
}

/**
 * What the user declared at connect — never a classification of their transactions.
 * `hasBusinessTransactions` is nullable, so it speaks for itself; `hasPersonalTransactions`
 * predates this flow and defaults to false, so it only counts as an answer once
 * `primaryUseSetAt` proves the question was asked.
 */
export const getDeclaredUse = (
  account: Pick<
    FinancialAccount,
    | 'primaryUse'
    | 'primaryUseSetAt'
    | 'hasPersonalTransactions'
    | 'hasBusinessTransactions'
  >
): DeclaredUse | null => {
  const {
    primaryUse,
    primaryUseSetAt,
    hasPersonalTransactions,
    hasBusinessTransactions,
  } = account

  if (!primaryUse) return null

  if (primaryUse === FinancialAccountPrimaryUse.PERSONAL) {
    return hasBusinessTransactions
      ? DeclaredUse.personalWithBusinessCharges
      : DeclaredUse.personal
  }

  return primaryUseSetAt && hasPersonalTransactions
    ? DeclaredUse.businessWithPersonalCharges
    : DeclaredUse.business
}
